var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Tạo đơn hàng"}},[_c('lading-form',{attrs:{"draft-id":_vm.draftId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }